<template>
  <div class="message-board">
    <van-nav-bar title="留言板" />

    <van-form @submit="onSubmit" class="message-form">
      <van-field
        v-model="newMessage.username"
        label="用户名"
        required
        clearable
        :rules="[{ required: true, message: '请输入用户名' }]"
      />
      <van-field
        v-model="newMessage.content"
        label="留言内容"
        required
        clearable
        type="textarea"
        rows="3"
        autosize
        :rules="[{ required: true, message: '请输入留言内容' }]"
      />
      <van-button round block type="info" native-type="submit">
        提交留言
      </van-button>
    </van-form>

    <van-list :finished="finished" :finished-text="finishedText" @load="onLoad">
      <div v-for="(message, index) in messages" :key="index">
        <van-cell
          :title="message.username"
          :value="message.content"
          :label="'留言时间: ' + message.time"
        />
        <van-cell
          v-if="message.reply"
          :title="'管理员回复: ' + message.reply.content"
          :label="'回复时间: ' + message.reply.time"
          class="admin-reply"
        />
      </div>
    </van-list>
  </div>
</template>

<script>
import { ref } from "vue";
import { NavBar, List, Cell, Form, Field, Button } from "vant";

export default {
  components: {
    [NavBar.name]: NavBar,
    [List.name]: List,
    [Cell.name]: Cell,
    [Form.name]: Form,
    [Field.name]: Field,
    [Button.name]: Button
  },
  setup() {
    const messages = ref([]);
    const finished = ref(false);
    const finishedText = ref("没有更多留言了");
    const newMessage = ref({
      username: "",
      content: ""
    });

    function onSubmit(values) {
      console.log("提交留言：", values);
      // 在这里将留言发送给服务器
      // 发送成功后，你可以清空输入框，例如：
      newMessage.value.username = "";
      newMessage.value.content = "";
    }

    function onLoad() {
      // 在这里请求服务器获取留言数据
      // 假设请求到的数据如下：
      const data = [
        {
          username: "用户1",
          content: "这是留言1",
          time: "2023-03-18 10:00",
          reply: {
            content: "管理员回复1",
            time: "2023-03-18 12:00"
          }
        },
        {
          username: "用户2",
          content: "这是留言2",
          time: "2023-03-18 11:00"
        }
      ];

      messages.value.push(...data);
      finished.value = true; // 设置为 true 表示没有更多数据需要加载
    }

    return {
      messages,
      finished,
      finishedText,
      onLoad,
      newMessage,
      onSubmit
    };
  }
};
</script>

<style scoped>
.message-board {
  font-size: 14px;
}
.message-form {
  padding: 15px;
}
.admin-reply {
  background-color: #f8f8f8;
  margin-left: 10px;
  margin-right: 10px;
}
</style>
